import Vue from 'vue'
import Vuex from 'vuex'
import modalsModule from '@/store/modals/modals'
import userModule from '@/store/user/user'
import tokensModule from 'asokoinsight-tokens/src/vuex/tokens'
import deals from '@/store/deals'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    modals: modalsModule,
    user: userModule,
    tokens: tokensModule,
    deals
  }
})
